export class selectedTimetableForNaviagtion {
  static readonly type = '[selectedTimetableForNaviagtion] timetable';
  constructor(public ttData: any) {}
}

export class selectedTeacherForTimetableNaviagtion {
  static readonly type = '[selectedTeacherForTimetableNaviagtion] timetable';
  constructor(public teacher: any) {}
}
